import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Tabs, H1, Loader } from '@itds/elements/index.js';

import General from './General';
import ModalFactors from './modal_factors/List';
import Bands from './bands/List';
import HealthCategories from './health_categories/List';
import TableRates from './table_rates/List';
import Riders from './riders/List';
import Formulas from './formulas/List';
import QuoteRates from './quote_rates/List';
import QuoteRatesEdit from './quote_rates/Edit';
import ImportCsv from './Import';
import Contributions from './contributions';
import AgeLimits from './age_limits';

import { Api } from '../../../utils/Api';
import BaseProduct from './BaseProduct';
import Investments from './investments/Investments';
import WithdrawalsAndSurrenders from './withdrawals_and_surrenders/WithdrawalsAndSurrenders';

const Show = () => {
  const navigate = useNavigate();
  const params = useParams();
  const hash = window.location.hash;

  const [version, setVersion] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDataVersion();
  }, []);

  const loadDataVersion = () => {
    setLoading(true);
    Api.loadAnnuityQuote(params.version_id).then(({ data }) => {
      setVersion(data);

      setLoading(false);
    });
  };

  const tabs = [
    {
      label: 'General',
      to: ' ',
      isActive:
        hash.slice(-1) === `${params.version_id}`.slice(-1) || hash.slice(-1) === '/'.slice(-1)
    },
    {
      label: 'Base Product',
      to: 'base_product',
      isActive: window.location.hash.includes('base_product')
    }
  ];

  if (version) {
    tabs.push(
      {
        label: 'Contributions',
        to: 'contributions',
        isActive: window.location.hash.includes('contributions')
      },
      {
        label: 'Age Limits',
        to: 'age_limits',
        isActive: window.location.hash.includes('age_limits')
      },
      {
        label: 'Riders',
        to: 'annuity_riders',
        isActive: window.location.hash.includes('annuity_riders')
      },
      {
        label: 'Investments',
        to: 'investments',
        isActive: window.location.hash.includes('investments')
      },
      {
        label: 'Import CSV',
        to: 'import_csv',
        isActive: window.location.hash.includes('import_csv')
      },
      {
        label: 'Withdrawals and Surrenders',
        to: 'withdrawals_and_surrenders',
        isActive: window.location.hash.includes('withdrawals_and_surrenders')
      }
    );
  }

  const props = { loadDataVersion, version };

  return loading ? (
    <Loader />
  ) : (
    <>
      <H1>{`Version ${params.version_id}`}</H1>
      <Breadcrumbs
        crumbs={[
          {
            label: 'Annuity Quotes',
            onClick: navigate.bind(null, `/carriers/${params.id}/annuity_quotes`)
          }
        ]}
        current={`Version ${params.version_id}`}
      />

      <div style={{ display: 'flex', margin: '0 -20px' }}>
        <Tabs tabs={tabs} vertical={true} width={130} />

        <div style={{ flex: 1, marginLeft: 40 }}>
          <Routes>
            <Route element={<General {...props} />} index={true} />
            <Route element={<BaseProduct {...props} />} path='base_product' />
            <Route element={<Contributions {...props} />} path='contributions' />
            <Route element={<AgeLimits {...props} />} path='age_limits' />
            <Route element={<Riders {...props} />} path='annuity_riders' />
            <Route element={<QuoteRatesEdit {...props} />} path='quote_rates/:rate_id/*' />
            <Route element={<ImportCsv {...props} />} path='import_csv' />
            <Route
              element={<WithdrawalsAndSurrenders {...props} />}
              path='withdrawals_and_surrenders'
            />
            <Route element={<Investments />} path='investments' />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default Show;
